
import Vue, { PropType } from "vue";
import AppFileUpload from "@/components/FileUpload.vue";
import { DossierConfigService } from "@/services";
import { PeppolSendOptions } from "@/utils/sale-edit/sale-edit-state-save-modal-data";
import { AuthService } from "@/services/auth-service";
import { Tier } from "@/utils/payments/tiers";
import { ContactPeppolEndpoint } from "@/models/base/contact-peppol-endpoint";
import { ISelectItem } from "winfakt-vue-components";

export default Vue.extend({
	data() {
		return {
			po: "",
			deliveryNumber: "",
			files: [] as File[],
			settings: DossierConfigService.getPluginConfig().UBL,
			sendCopyToBookkeeper: false,
			endpointID: ""
		};
	},
	props: {
		value: {
			type: Object as () => PeppolSendOptions,
			required: true
		},
		endpoints: {
			type: Array as PropType<ContactPeppolEndpoint[]>,
			default: () => []
		}
	},
	computed: {
		maxFileSize():number {
			let baseSize = 50e6;
			for (let file of this.files) {
				baseSize -= file.size;
			}
			return baseSize;
		},
		bookkeeperEmail():string {
			return this.settings.BookkeeperEmailConfigs?.sales?.Email || "";
		},
		endpointItems():ISelectItem<string>[] {
			let items = this.endpoints
				.filter((e:ContactPeppolEndpoint) => e.getFullID() !== "")
				.map((e:ContactPeppolEndpoint) => ({ value: e.getFullID(), text: e.getDisplayName() } as ISelectItem<string>));
			return items.filter((item:ISelectItem<string>, i:number) => items.findIndex((x:ISelectItem<string>) => x.value === item.value) === i);
		}
	},
	methods: {
		close() {
			this.$emit("close");
		},
		save() {
			const options: PeppolSendOptions = {
				po: this.po,
				deliveryNumber: this.deliveryNumber,
				files: this.files,
				sendCopyToBookkeeper: this.sendCopyToBookkeeper,
				endpointID: this.endpointID
			};
			this.$emit("input", options);
			this.$emit("close");
		},
		onFileInput(file: File) {
			this.files.push(file);
		},
		removeFile(i: number) {
			this.files.splice(i, 1);
		}
	},
	mounted() {
		this.po = this.value.po;
		this.deliveryNumber = this.value.deliveryNumber;
		this.files = [...this.value.files];
		this.sendCopyToBookkeeper = this.value.sendCopyToBookkeeper ||
			(this.settings.PeppolSendCopyToBookkeeper && this.bookkeeperEmail !== "" && AuthService.wfCompany.Tier >= Tier.ENTERPRISE);
		if (this.value.endpointID) {
			this.endpointID = this.value.endpointID;
		} else {
			let endpoints = this.endpoints.filter((e:ContactPeppolEndpoint) => e.getFullID() !== "");
			let preferred = endpoints.find((e:ContactPeppolEndpoint) => e.IsDefault) || endpoints[0];
			this.endpointID = preferred ? preferred.getFullID() : "";
		}
	},
	components: {
		AppFileUpload
	},
	i18nEx: {
		componentPrefix: "components.sales"
	}
});
